<template>
    <InputContainer :label="label" :name="name" :errors="errors" :showErrors="showErrors">
        <div class="base-input-container simple-datepicker">
            <DatePicker v-bind="$attrs" :modelValue="modelValue" @input="handleInput" :masks="masks">
                <template #default="{ inputValue, inputEvents }">
                    <input
                        :value="inputValue"
                        v-on="inputEvents"
                        class="base-input"
                        :placeholder="placeholder ? placeholder : ''"
                    />
                </template>
            </DatePicker>
        </div>
    </InputContainer>
</template>
<script>
import { DatePicker } from "v-calendar";
import inputs from "@/mixins/inputs.js";
import InputContainer from "@/components/inputs/InputContainer";

export default {
    name: "LaSimpleDatePicker",
    components: {
        InputContainer,
        DatePicker,
    },
    mixins: [inputs],
    props: {
        modelValue: {
            type: [String, Object],
            required: true,
        },
        placeholder: {
            type: [String, Object],
            required: false,
        },
    },
    setup() {
        const masks = {
            input: ["YYYY-MM-DD", "iso"],
            output: ["iso"],
        };
        return {
            masks,
        };
    },
};
</script>

<style lang="scss" scoped>
.base-input-container {
    min-width: 20rem;
    @include --big-mobile-viewport {
        min-width: inherit;
        font-size: 0.9rem;
    }
}

:deep(.base-input-container > div) {
    width: 100%;
}

:deep(.base-input) {
    width: 100%;
    background-color: $light-blue;
    border: 1px solid darken($light-blue, 15%);
    border-radius: $normal-radius;
    box-shadow: none;
    padding: 0.9rem 0.7rem;
    color: $blue;
    box-sizing: border-box;

    &:disabled {
        cursor: not-allowed;
        background: $dark-grey;
    }
}
</style>

<style lang="scss">
body.dark .simple-datepicker .base-input {
    background: $input-background;
    border: 1px solid $dark-grey-3;
    color: $text;
}

body.variant-performax .simple-datepicker .base-input {
    background: $white;
    border: 1px solid $px-purple;
    color: $black;
    padding: 1.25rem;

    &::placeholder {
        color: rgba($px-purple, 0.6);
    }
}
</style>
